__turbopack_context__.v({
  "arrow": "tooltip-module-scss-module__nVFTCG__arrow",
  "content": "tooltip-module-scss-module__nVFTCG__content",
  "tooltip-in": "tooltip-module-scss-module__nVFTCG__tooltip-in",
  "tooltip-out": "tooltip-module-scss-module__nVFTCG__tooltip-out",
});
